import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "layout__wrapper-inner container library-page__container" }

import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import RootPageLayout from '@/app/components/RootPageLayout.vue'
import LibraryHeader from './LibraryHeader.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'LibraryLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_LoadingError = _resolveComponent("LoadingError")!
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createBlock(RootPageLayout, {
    class: "library-page",
    title: "My Library"
  }, {
    header: _withCtx(() => [
      _createVNode(LibraryHeader, { class: "library-header__mobile" })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_wait, { for: "Error Loading Library" }, {
        waiting: _withCtx(() => [
          _createVNode(_component_LoadingError)
        ]),
        _: 1
      }),
      _createVNode(_component_v_wait, { for: "Loading Library" }, {
        waiting: _withCtx(() => [
          _createVNode(LoadingSpinner)
        ]),
        _: 1
      }),
      _createVNode(LibraryHeader, { class: "library-header__desktop" }),
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }))
}
}

})